var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogohover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "he2hover",
    transform: "translate(-1573 214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    width: 50,
    height: 50,
    transform: "translate(1573 -214)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_15_6",
    "data-name": "Component 15 \\u2013 6",
    transform: "translate(1576 -212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M158.613,305.5a19.227,19.227,0,0,1-29.569,0,4.224,4.224,0,1,0-6.495,5.4,27.708,27.708,0,0,0,42.558,0,4.224,4.224,0,1,0-6.495-5.4Z",
    transform: "translate(-121.578 -282.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M115.355,160.132a4.654,4.654,0,0,1,8.683,0l1.309,2.343a1.091,1.091,0,0,0,1.282.51,1.1,1.1,0,0,0,.786-1.144c-.455-5.8-4.438-9.841-7.718-9.841s-7.264,4.038-7.718,9.841a1.115,1.115,0,0,0,.786,1.144,1.129,1.129,0,0,0,1.282-.51Z",
    transform: "translate(-108.471 -148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M279.7,152c-3.28,0-7.264,4.038-7.718,9.841a1.109,1.109,0,0,0,2.067.634l1.309-2.343a4.654,4.654,0,0,1,8.683,0l1.309,2.343a1.091,1.091,0,0,0,1.282.51,1.1,1.1,0,0,0,.786-1.144C286.96,156.038,282.977,152,279.7,152Z",
    transform: "translate(-246.418 -152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M11.618,29.33s10.91,26.145,20.06,4.99",
    transform: "translate(-5.631 11.843) rotate(-25)",
    fill: "#f2b900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M146.854,304.573a20.08,20.08,0,0,1-20.181,0,4.5,4.5,0,0,0-4.06-.214c-1.225.587-1.381,1.629-.372,2.333,3.6,2.485,8.9,3.907,14.523,3.907s10.919-1.422,14.523-3.907c1.021-.7.853-1.746-.372-2.333A4.5,4.5,0,0,0,146.854,304.573Z",
    transform: "translate(-157.597 -251.427) rotate(-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogohover);
export default __webpack_public_path__ + "static/media/login-logohover.e4344c2e58b037714555911bda71049d.svg";
export { ForwardRef as ReactComponent };